let inject = [

  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings'
];

class CategoriesAccordionController{
  constructor ($scope, $state, $rootScope, SharedService, ngAuthSettings) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;

    this.status ={
      open:false
    };
  }

  $onInit(){
  }
}

CategoriesAccordionController.$inject = inject;

export default CategoriesAccordionController;





/** WEBPACK FOOTER **
 ** ./www/components/catalog/categories-filter/categories-accordion/categories-accordion.controller.js
 **/